<template>
  <div class="yaowen">
    <div class="width1000 margintb container">
      <div class="banner">
        <el-carousel height="415px"
                     arrow="always"
                     indicator-position="none"
                     :initial-index="currentIndex"
                     @change="doChange">
          <el-carousel-item v-for="(item,index) in dataList.data.img"
                            :key="index">
            <a v-if="item.dataType=='article'"
               :href="'/h5/detail.html?artId='+item.dataVal"
               target="_blank "><img :src="item.imgUrl" /></a>
            <a v-else
               :href="item.dataVal"
               target="_blank "><img :src="item.imgUrl" /></a>
          </el-carousel-item>
        </el-carousel>
        <div class="bottomPage">
          <a v-if="dataList.data.img[currentIndex].dataType=='article'"
             :href="'/h5/detail.html?artId='+dataList.data.img[currentIndex].dataVal"
             target="_blank ">{{dataList.data.img[currentIndex].title}}</a>
          <a v-else
             :href="dataList.data.img[currentIndex].dataVal"
             target="_blank ">{{dataList.data.img[currentIndex].title}}</a>

          <span class="text">
            <b>{{currentIndex+1}}</b>
            /
            <b>{{dataList.data.img.length}}</b>
          </span>
        </div>
      </div>
      <div class="aboutNews">
        <div class="top">
          <!-- <span>
            <a href="http://society.people.com.cn/GB/369130/431577/index.html"
               target="_blank"></a>
            <a href="http://society.people.com.cn/GB/369130/431577/index.html"
               class="wzlink"
               target="_blank">专题&gt;&gt;</a>
          </span> -->
        </div>
        <div class="context">
          <ul>
            <li v-for="(item,index) in dataList.data.txt"
                :key="index">
              <a v-if="item.dataType=='article'"
                 :href="'/h5/detail.html?artId='+item.dataVal"
                 target="_blank ">{{item.title}}</a>
              <a v-else
                 :href="item.dataVal"
                 target="_blank ">{{item.title}}</a>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentIndex: 0,
    }
  },
  props: ['dataList'],
  mounted () {
    // console.log(this.dataList);
  },
  methods: {
    doChange (index) {
      this.currentIndex = index;
    },
    // gotoDetail (artId) {

    // },
  },
  watch: {
    dataList (val) {

      this.dataList = val;
    }
  }
}
</script>
<style lang="less">
.yaowen {
  .container {
    position: relative;
  }
  .banner {
    width: 656px;
    height: 414px;
    position: relative;
    .el-carousel__arrow {
      background-color: rgba(0, 0, 0, 0.5);
    }
    img {
      width: 100%;
      height: 100%;
    }
    .bottomPage {
      width: 100%;
      height: 60px;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 8;
      text-align: center;
      .text {
        color: #fff;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -10px;
      }
      a {
        color: #fff;

        line-height: 60px;
        font-size: 14px;
      }
    }
  }
  .aboutNews {
    position: absolute;
    top: 0;
    right: 0;
    width: 330px;
    height: auto;

    // .top {
    //   width: 100%;
    //   height: 44px;
    //   background: url('http://www.people.com.cn/img/2019peopleindex/images/zhuanqu/20200127/yqtit.png')
    //     no-repeat top center;
    //   background-size: 100% 100%;
    // }
    .context {
      width: 100%;
      height: 414px;
      // background: #afd1fa;
      overflow: hidden;

      ul {
        padding: 0px 0 4px 0;
        margin-left: 15px;
        color: #103d74;

        li {
          font-size: 14px;
          font-family: 'SimSun';
          padding: 0px 0 14px 0;
          height: 24px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 24px;
          a {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      ul li a:link,
      ul li a:visited {
        color: #333;
      }
      ul li a:hover {
        color: #e60012;
      }
    }
  }
}
</style>
